<!-- 库存盘点 -->
<template>
  <div class="app-container">
    <Table
      ref="tableRef"
      :showSearchIcon="true"
      :isCreateSearch="false"
      :showText="true"
      :isSelect="true"
      :data="tableData"
      :columns="columns"
      :total="total"
      :loading="loading"
      :disabledBtn="disabledBtn == '1'"
      rowKey="checkInventoryProductRecordId"
      exportDataUrl="/checkInventory/selectCheckInventoryProductRecord"
      tableName="checkInventory"
      :customParamsFun="getCustomParamsFun"
      @onSearch="handleSearch"
      @changeInput="changeInput"
    >
      <template #funBtn>
        <el-row :gutter="8">
          <el-col :span="1.5">
            <el-button
              type="primary"
              :disabled="disabledBtn == '1'"
              @click="handleCheckInput"
              >盘库录入</el-button
            >
          </el-col>
          <el-col :span="1.5">
            <el-button
              type="primary"
              :disabled="disabledBtn == '1'"
              @click="
                handleCheckEnd({ pageIndex: 1, pageSize: pageSizeDialogErr })
              "
              >盘库结束</el-button
            >
          </el-col>
        </el-row>
      </template>
      <template #textInfo>
        <el-row class="textInfo" :gutter="8">
          <el-col :span="5">
            <div>
              <span class="textName">{{
                checkInventoryRecord.warehouseName
              }}</span>
            </div>
          </el-col>
          <el-col :span="5">
            <div>
              <span class="textName">主材：</span
              >{{ checkInventoryRecord.mainMaterialTotal || 0 }}
            </div>
          </el-col>
          <el-col :span="5">
            <div>
              <span class="textName">辅材：</span
              >{{ checkInventoryRecord.auxiliaryMaterialTotal || 0 }}
            </div>
          </el-col>
          <el-col :span="4">
            <div>
              <span class="textName">耗材：</span
              >{{ checkInventoryRecord.consumptionMaterialTotal || 0 }}
            </div>
          </el-col>
          <el-col :span="5">
            <div>
              <span class="textName">总数：</span
              >{{ checkInventoryRecord.inventoryTotal || 0 }}
            </div>
          </el-col>
        </el-row>
      </template>
    </Table>
    <!-- 详情 -->
    <el-dialog
      :title="dialogTitle"
      v-model="dialogOpen"
      width="1200px"
      append-to-body
      @close="closed"
    >
      <Table
        ref="tableRefDialog"
        :showSearchIcon="true"
        :isSelect="true"
        :data="tableDataDialog"
        :columns="columnsDialog"
        :total="totalDialog"
        :loading="loadingDialog"
        :disabledBtn="disabledBtn == '1'"
        rowKey="productInventoryId"
        tableName="checkInventoryProDetail"
        exportDataUrl="/checkInventory/selectCheckInventoryCheckRecord"
        :customParamsFun="getCustomParamsFunPro"
        @onSearch="handleSearchDialog"
        @changeSelect="changeSelect"
      >
        <template #funBtn>
          <el-button
            type="primary"
            :disabled="disabledBtn == '1'"
            @click="handleCheckInput"
            >盘库录入</el-button
          >
        </template>
      </Table>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="closed">关闭</el-button>
          <!-- <el-button type="primary" @click="onConfirm">{{ $t('msg.universal.confirm') }}</el-button> -->
        </span>
      </template>
    </el-dialog>
    <!-- 盘库结束 -->
    <el-dialog
      title="盘点异常"
      v-model="dialogOpenEnd"
      width="1200px"
      append-to-body
    >
      <span class="mb10" style="font-size: 25px; color: red"
        >以下设备未盘点请仔细核对，可直接修改状态</span
      >
      <Table
        ref="tableRefDialogErr"
        :showSearchIcon="false"
        :data="tableDataDialogEnd"
        :columns="columnsDialog"
        :total="totalDialogErr"
        :loading="loadingDialogErr"
        :pageSize="pageSizeDialogErr"
        :showSearchComponents="false"
        height="500px"
        rowKey="checkInventoryProductRecordId"
        @onSearch="handleCheckEnd"
      >
      </Table>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="closed">关闭</el-button>
          <el-button type="primary" @click="handleCheckEndConfirm"
            >确认</el-button
          >
        </span>
      </template>
    </el-dialog>
    <checkInEqpt
      v-model="addEqptDialogOpen"
      :data="addEqptData"
      @success="handleAddEqptSuccess"
      @closeDialog="closeDialog"
      :titleName="titleName"
      :showTable="showTable"
      :tableData="tableDataAdd"
      :tableDataErr="tableDataAddErr"
      :columns="columnsDialogCheck"
    />
    <!-- 单独盘点-不是同一主材提示 -->
    <el-dialog
      title="提示"
      v-model="dialogOpenNotThisPro"
      width="1200px"
      append-to-body
    >
      <span class="pb10" style="font-size: 25px; color: red"
        >以下数据不是该产品下设备，请确定是否继续录入！</span
      >
      <Table
        ref="tableRefDialogNotThisPro"
        :showSearchIcon="false"
        :showFun="false"
        :data="tableDataDialogNotThisPro"
        :columns="columnsDialogCheck"
        rowKey="productInventoryId"
      >
      </Table>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="closedNotThisPro">关闭</el-button>
          <el-button type="primary" @click="onConfirmNotThisPro">{{
            $t("msg.universal.confirm")
          }}</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import Table from "@/components/Element/Table";
import { ref, watch, onMounted, getCurrentInstance } from "vue";
import { getCustomTableCols } from "@/tableColumn";
import {
  selectCheckInventoryProductRecord,
  selectCheckInventoryCheckRecord,
  checkInput,
  checkEnd,
  selectMainCheckError,
  selectOtherCheckError,
  updateCheckStatus,
  updateActualTotal,
  updateInventoryTotal,
} from "@/api/checkInventory";
import checkInEqpt from "./checkInEqpt.vue";
import useCacheStore from "@/store/modules/cache";
import { isNull, feArrayObjectJoin } from "@/utils/fangerUtils";
//   import { feArrayObjectJoin } from "@/utils/fangerUtils";
import { succesMsg, infoMsg, errorMsg, confirmBox } from "@/utils/msgBox";
import useInventoryStore from "@/store/modules/inventory";
const inventoryStore = useInventoryStore();
const cacheStore = useCacheStore();
const { proxy } = getCurrentInstance();
const { getWarehouseNameById, getDictNameByPCodeSCode } = cacheStore;
const props = defineProps({
  checkInventoryRecord: {
    // 盘库id
    required: false,
    type: Object,
  },
});
onMounted(() => {
  watch(
    () => props.checkInventoryRecord,
    (newVal, oldVal) => {
      disabledBtn.value = newVal.status;
      tableRef.value.onSearch();
      // proSearch()
    },
    {
      immediate: true,
      deep: true,
    }
  );
  if (sessionStorage.getItem("checkInventoryStatus") === "1") {
    disabledBtn.value = "1";
  }
});
const tableRef = ref(null);
const tableData = ref([]);
const total = ref(0);
const loading = ref(false);
const tableDataDialog = ref([]);
const tableDataDialogEnd = ref([]);
const totalDialog = ref(0);
const loadingDialog = ref(false);
const dialogOpen = ref(false);
const dialogTitle = ref("详情");
const addEqptData = ref([]);
const tableDataAdd = ref([]);
const tableDataAddErr = ref([]);
const tableDataDialogNotThisPro = ref([]);
const addEqptDialogOpen = ref(false);
const dialogOpenNotThisPro = ref(false);
const showTable = ref(false);
const disabledBtn = ref("0");
const titleName = ref("");
// 主材错误数据
const totalDialogErr = ref(0);
const pageSizeDialogErr = ref(50);
const loadingDialogErr = ref(false);

const searchAttrName = ["productName", "productType", "usageType"];
const handleCheckInput = () => {
  addEqptDialogOpen.value = true;
};
// 添加设备成功
const handleAddEqptSuccess = (data) => {
  const productCodes = feArrayObjectJoin(data, "eqptCode", ",");
  checkInput({
    eqptCodes: productCodes,
    warehouseId: warehouseId.value,
    checkInventoryRecordId: props.checkInventoryRecord.checkInventoryRecordId,
    productId: productId.value,
  }).then((res) => {
    addEqptData.value = [];
    if (res.data.success.length > 0) {
      succesMsg("录入成功");
      showTable.value = true;
      tableDataAdd.value = res.data.success;
    }
    if (res.data.notThisProduct.length > 0) {
      tableDataDialogNotThisPro.value = res.data.notThisProduct;
      dialogOpenNotThisPro.value = true;
    }
    tableDataAddErr.value = res.data.error;
  });
};
const closedNotThisPro = () => {
  tableDataDialogNotThisPro.value = [];
  dialogOpenNotThisPro.value = false;
};
const onConfirmNotThisPro = () => {
  productId.value = null;
  const productCodes = feArrayObjectJoin(
    tableDataDialogNotThisPro.value,
    "eqptCode",
    ","
  );
  checkInput({
    eqptCodes: productCodes,
    warehouseId: warehouseId.value,
    checkInventoryRecordId: props.checkInventoryRecord.checkInventoryRecordId,
  }).then((res) => {
    if (res.data.success.length > 0) {
      succesMsg("录入成功");
    } else {
      infoMsg("录入失败");
    }
    tableDataDialogNotThisPro.value = [];
    dialogOpenNotThisPro.value = false;
  });
};
const tableRefDialog = ref(null);
const closeDialog = () => {
  tableDataAdd.value = [];
  addEqptData.value = [];
  tableDataAddErr.value = [];
  showTable.value = false;
  addEqptDialogOpen.value = false;
  if (tableRefDialog.value) {
    tableRefDialog.value.onSearch();
  }
};
//   盘库结束
const dialogOpenEnd = ref(false);
const handleCheckEnd = (data) => {
  pageSizeDialogErr.value = data.pageSize;
  selectOtherCheckError({
    checkInventoryRecordId: props.checkInventoryRecord.checkInventoryRecordId,
  }).then((res) => {
    if (res.data.length > 0) {
      errorMsg("存在未盘点辅材/耗材数据");
      return;
    } else {
      loadingDialogErr.value = true;
      selectMainCheckError({
        checkInventoryRecordId:
          props.checkInventoryRecord.checkInventoryRecordId,
        ...data,
      })
        .then((res) => {
          loadingDialogErr.value = false;
          if (res.data.length > 0) {
            // dialogTitle.value = '异常设备'
            dialogOpenEnd.value = true;
            tableDataDialogEnd.value = res.data;
            totalDialogErr.value = res?.pageParam?.totleInfo
              ? res.pageParam.totleInfo
              : 0;
          } else {
            checkEnd({
              checkInventoryRecordId:
                props.checkInventoryRecord.checkInventoryRecordId,
            })
              .then((res) => {
                succesMsg("盘点结束");
                sessionStorage.setItem("checkInventoryStatus", "1");
                disabledBtn.value = "1";
                inventoryStore.checkInventoryStatus = "1";
              })
              .catch((err) => {
                errorMsg(err.message);
              });
          }
        })
        .finally(() => {
          loadingDialogErr.value = false;
        });
    }
  });
};
// 盘库结束存在异常数据后 确认
const handleCheckEndConfirm = () => {
  confirmBox("是否确定盘点结束，未盘点设备的状态都将改为丢失")
    .then(async () => {
      checkEnd({
        checkInventoryRecordId:
          props.checkInventoryRecord.checkInventoryRecordId,
      })
        .then((res) => {
          succesMsg("盘点结束");
          sessionStorage.setItem("checkInventoryStatus", "1");
          disabledBtn.value = "1";
          inventoryStore.checkInventoryStatus = "1";
        })
        .catch((err) => {
          errorMsg(err.message);
        });
    })
    .catch((err) => {});
};

const warehouseId = ref();
const getCustomParamsFun = () => {
  return {
    checkInventoryRecordId: props.checkInventoryRecord.checkInventoryRecordId,
  };
};
// 搜索
const handleSearch = (data) => {
  loading.value = true;
  selectCheckInventoryProductRecord(data)
    .then((res) => {
      warehouseId.value = res.data[0].warehouse;
      tableData.value = res.data;
      total.value = res?.pageParam?.totleInfo ? res.pageParam.totleInfo : 0;
    })
    .finally(() => {
      loading.value = false;
    });
};
const checkInventoryProductRecordId = ref("");
const getCustomParamsFunPro = () => {
  return {
    checkInventoryProductRecordId: checkInventoryProductRecordId.value,
  };
};
//   详情
const handleSearchDialog = (data) => {
  loading.value = true;
  selectCheckInventoryCheckRecord(data)
    .then((res) => {
      const arr = [];
      res.data.forEach((item) => {
        item.checkStatus = getDictNameByPCodeSCode(
          "checkStatus",
          item.checkStatus
        );
      });
      tableDataDialog.value = res.data;
      totalDialog.value = res.pageParam.totleInfo;
    })
    .finally(() => {
      loading.value = false;
    });
};
// 修改详情状态
const changeSelect = (row) => {
  updateCheckStatus({
    checkInventoryCheckRecordId: row.checkInventoryCheckRecordId,
    checkStatus: row.checkStatus,
  })
    .then((res) => {
      succesMsg("修改成功");
    })
    .catch((err) => {
      errorMsg("修改失败");
    });
};
//   修改列表实际在库数量
const changeInput = (row) => {
  updateActualTotal({
    checkInventoryProductRecordId: row.checkInventoryProductRecordId,
    actualTotal: row.actualTotal,
  })
    .then((res) => {
      if (res.status == 1) {
        succesMsg("修改成功");
      }
    })
    .catch((err) => {
      errorMsg("修改失败");
    });
};
const productId = ref(null);
const handleDetail = (event, row) => {
  dialogTitle.value = "详情";
  titleName.value = row.productName;
  dialogOpen.value = true;
  checkInventoryProductRecordId.value = row.checkInventoryProductRecordId;
  productId.value = row.productId;
  proxy.$nextTick(() => {
    tableRefDialog.value.onSearch();
  });

  // handleSearchDialog({pageIndex:1,pageSize:10})
};
const closed = () => {
  dialogOpen.value = false;
  dialogOpenEnd.value = false;
  checkInventoryProductRecordId.value = "";
  productId.value = null;
  tableDataDialog.value = [];
  tableDataDialogEnd.value = [];
  tableRef.value.onSearch();
};
const handleControlDisabled = (row) => {
  return row.usageType !== "1";
};
const columns = getCustomTableCols([
  "productName",
  "productType",
  "warehouse",
  "usageType",
  "inventoryStatus",
  "inventoryTotal",
  "actualTotal",
  "checkingOutInventoryTotal",
  "operateTime",
  "operatorName",
  {
    label: "操作",
    prop: "action",
    type: "action",
    search: false,
    action: [
      {
        control: "button",
        controlName: "详情",
        controlType: "success",
        controlText: true,
        controlFun: handleDetail,
        controlDisabled: handleControlDisabled,
      },
    ],
  },
]);
const columnsDialog = getCustomTableCols([
  "eqptCode",
  "inventoryOperationType",
  "inventoryStatus",
  "inWarehouseTime",
  "outWarehouseTime",
  "status",
  "checkTime",
  "remarks",
  "operateTime",
  "operatorName",
]);
columnsDialog.splice(5, 0, {
  // 盘点状态
  label: "盘点状态",
  prop: "checkStatus",
  type: "select",
  dictKey: "checkStatus",
});
const columnsDialogCheck = getCustomTableCols([
  "eqptCode",
  "inventoryOperationType",
  "inventoryStatus",
  "inWarehouseTime",
  "outWarehouseTime",
  "status",
  "checkStatus",
  "checkTime",
  "remarks",
  "operateTime",
  "operatorName",
]);
</script>

<style lang="scss" scoped>
.textInfo {
  font-size: 18px;
  width: 80%;
  color: #ed064b;
  font-weight: bold;
  .textName {
    font-size: 20px;
    color: #555;
  }
}
</style>
